var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "dropdown" } }, [
    _c("div", { staticClass: "dropdown-filter" }, [
      _vm.hasSelection
        ? _c("div", { staticClass: "row no-gutters" }, [
            _vm.filter.vector
              ? _c(
                  "div",
                  {
                    staticClass: "alink mr-1",
                    on: {
                      click: function($event) {
                        return _vm.onRemove("vector")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mr-2" }, [_vm._v("VETTORE")]),
                    _c("b", [_vm._v(_vm._s(_vm.filter.vector.objA))])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isFullTimeOrario()
              ? _c(
                  "div",
                  { staticClass: "alink", on: { click: _vm.onRemoveOrario } },
                  [
                    _c("span", { staticClass: "mr-2" }, [_vm._v("ORARIO")]),
                    _c("b", [_vm._v(_vm._s(_vm.orario))])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.filter.scalo
              ? _c(
                  "div",
                  {
                    staticClass: "alink",
                    on: {
                      click: function($event) {
                        return _vm.onRemove("scalo")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mr-2" }, [_vm._v("SCALO")]),
                    _c("b", [_vm._v(_vm._s(_vm.scali[_vm.filter.scalo - 1]))])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.filter.partenza
              ? _c(
                  "div",
                  {
                    staticClass: "alink mr-1",
                    on: {
                      click: function($event) {
                        return _vm.onRemove("partenza")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mr-2" }, [_vm._v("PARTENZA")]),
                    _c("b", [_vm._v(_vm._s(_vm.filter.partenza.label))])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.filter.atterraggio
              ? _c(
                  "div",
                  {
                    staticClass: "alink",
                    on: {
                      click: function($event) {
                        return _vm.onRemove("atterraggio")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mr-2" }, [
                      _vm._v("ATTERRAGGIO")
                    ]),
                    _c("b", [_vm._v(_vm._s(_vm.filter.atterraggio.label))])
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "bg-white" }, [
        _c("form", [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Vettore")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "row no-gutters pl-3 py-2 pl-md-5 py-md-3 bg-light",
                style: _vm.isMobile ? "max-height: 160px; overflow: auto" : ""
              },
              _vm._l(_vm.vectors, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12 col-md-4" },
                  [
                    _c("div", { staticClass: "pretty p-default p-curve" }, [
                      _c("input", {
                        attrs: { type: "radio", name: "vector" },
                        domProps: { checked: _vm.isCheckedVector(item) },
                        on: {
                          click: function($event) {
                            return _vm.onSelect("vector", item)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-secondary-o" }, [
                        _c("label", [_vm._v(_vm._s(item.objA))])
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Orario di partenza")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row no-gutters pl-3 pl-md-5 py-3 bg-light" },
              [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("TimeRangeSlider", {
                      attrs: { value: _vm.filter.orario },
                      on: { input: _vm.onInputOrario }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Scali")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row no-gutters pl-2 pl-md-5 py-3 bg-light" },
              _vm._l(_vm.scali, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12 col-md-4" },
                  [
                    _c("div", { staticClass: "pretty p-default p-curve" }, [
                      _c("input", {
                        attrs: { type: "radio", name: "scalo" },
                        domProps: { checked: _vm.isCheckedScalo(index + 1) },
                        on: {
                          click: function($event) {
                            return _vm.onSelect("scalo", index + 1)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-secondary-o" }, [
                        _c("label", [_vm._v(_vm._s(item))])
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0cd2940", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0cd2940","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/volo-hotel/dropdown/DropdownFilterFlight.vue
// module id = null
// module chunks = 